module.exports = __webpack_public_path__ + "img/innovashen-2019-02.0a623802.jpg";